// Panel está dentro de R3Div pois um panel também vai ser uma div

import { R3VisualComponentBase } from "../../../../classes/base/R3VisualComponenteBase.classes";

export class R3PanelClass extends R3VisualComponentBase {

}